<template>
  <div class="clear-table-box">
    <el-table :data="tableData" stripe style="width: 100%">
      <el-table-column prop="tradeDate" label="交易日期" width="100">
        <template slot-scope="scope">
          {{
            (scope.row.tradeDate && scope.row.tradeDate.substring(0, 10)) || "-"
          }}
        </template>
      </el-table-column>
      <el-table-column
        prop="sumAmount"
        align="right"
        label="收款金额"
        min-width="100"
      >
        <template slot-scope="scope">
          {{ scope.row.sumAmount | numberFormat }}
        </template>
      </el-table-column>
      <el-table-column
        prop="sumRefundAmount"
        label="退款金额"
        align="right"
        min-width="100"
      >
        <template slot-scope="scope">
          {{ scope.row.sumRefundAmount | numberFormat }}
        </template>
      </el-table-column>
      <el-table-column
        prop="orderSum"
        align="right"
        label="收款笔数"
        min-width="110"
      >
        <template slot-scope="scope">
          {{ scope.row.orderSum | numberFormat("0", ".", ",") }}
        </template>
      </el-table-column>
      <el-table-column
        prop="refundSum"
        align="right"
        label="退款笔数"
        min-width="80"
        ><template slot-scope="scope">
          {{ scope.row.refundSum | numberFormat("0", ".", ",") }}
        </template>
      </el-table-column>
      <el-table-column prop="fee" align="right" label="手续费" min-width="100">
        <template slot-scope="scope">
          {{ scope.row.fee | numberFormat }}
        </template>
      </el-table-column>
      <el-table-column
        prop="settleAmount"
        label="应清算金额"
        align="right"
        min-width="100"
      >
        <template slot-scope="scope">
          {{ scope.row.settleAmount | numberFormat }}
        </template>
      </el-table-column>
      <el-table-column v-if="userAuth.exportBill" label="操作" width="120">
        <template slot-scope="scope">
          <el-button
            v-preventReClick
            @click="goDownload(scope.row.tradeDate)"
            type="text"
            >下载</el-button
          >
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  data() {
    return {
      createTime: "",
      id: "",
      outOrderNo: "",
      extNum: "",
      payTypeName: "",
      amount: "",
      payStatusName: "",
      note: "",
      refundstatus: "",
      isInvoiced: "",
      applytime: "",
      refundid: "",
      createUser: "",
      refundmoney: "",
      refundReason: "",
      time: "",
      ordernum: "",
      paytype: "",
      paymoney: "",
      reason: "",
      reasonerr: "",
      password: "",
      pderr: "",
      refund: false,
      orderdetails: false,
      details: false
    };
  },
  props: {
    tableData: {
      type: Array,
      default: () => {}
    },
    userAuth: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  methods: {
    goDownload(tradeDate) {
      this.$emit("download", tradeDate);
    }
  }
};
</script>

<style scoped lang="scss"></style>
